import { createContext, PropsWithChildren, useContext } from "react";
import {
  useProvideCurrentUserInfo,
  type CurrentUserInfoValue,
} from "../hooks/useProvideCurrentUserInfo";

export const UserInfoContext = createContext<CurrentUserInfoValue | null>(null);

export const UserInfoProvider = ({ children }: PropsWithChildren) => (
  <UserInfoContext.Provider value={useProvideCurrentUserInfo()}>{children}</UserInfoContext.Provider>
);

export const useCurrentUserInfo = (): CurrentUserInfoValue => {
  const ctx = useContext(UserInfoContext);
  if (!ctx) {
    throw new Error("useCurrentUserInfo must be used within UserInfoProvider");
  }
  return ctx;
};
